import { ClerkProvider } from "@clerk/clerk-react";
import { nbNO } from "@clerk/localizations";

import { env } from "@/env";

export default function ClerkProviderWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <ClerkProvider
      publishableKey={env.VITE_CLERK_PUBLISHABLE_KEY}
      afterSignOutUrl="/"
      localization={nbNO}
    >
      {children}
    </ClerkProvider>
  );
}

declare module "@clerk/types" {
  interface OrganizationPublicMetadata {
    locations?: string[];
    isSystemAdminOrg?: boolean;
  }

  interface ClerkAuthorization {
    permission: unknown;
    role: "org:admin" | "org:manager" | "org:front_desk" | "org:guide";
  }

  interface UserPublicMetadata {
    locations?: string[];
    role?: "system-admin" | "manager" | "front-desk" | "guide";
  }
}
